import { Renderer } from "@with-nx/cms-ui";
import { Rule } from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { CatalogLayout } from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";

import LegalMenuDesktop from "../../components/w/LegalMenuDesktop";

export default function Page() {
  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Cancellation Policy"
      description="This Cancellation Policy document was last updated on June 30, 2023"
    >
      <ReusableSection>
        <div className="container mx-auto max-w-7xl">
          <Row gutter={[36, 18]} justify="space-between">
            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
              <LegalMenuDesktop />
            </Col>
            <Col xs={24} sm={24} md={24} lg={18} xl={18}>
              <Rule rule="hs" color="var(--font1)" display="block" bottom={24}>
                Cancellation Policy
              </Rule>
              <Rule rule="ls" color="var(--font3)" display="block" bottom={24}>
                This Cancellation Policy document was last updated on June 30,
                2023
              </Rule>
              <Renderer
                data={{
                  blocks: [
                    {
                      type: "paragraph",
                      data: {
                        text: `At Broadway Media, customer satisfaction is our priority. We strive to provide refunds, repairs, and replacements according to the terms outlined in this policy. For any further clarification on our policies, please contact us directly at accounts@broadwaymedia.com.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `I. Cancellations, Refunds, and Order Adjustments You may request a cancellation and receive a refund or credit until the date of download of the product, as per the eligibility requirements mentioned below. Once the product has been downloaded, Broadway Media will not accept cancellation requests or offer refunds based on preference or price.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `A. Cancellation Refund Eligibility:`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(i) You may request a cancellation and receive a refund until the download of the product or the first date of your license period, whichever occurs first.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(ii) If your order was placed less than 14 days before the start of your license period, you may request a cancellation and receive a refund within 14 days from the order date or until the download of the product, whichever occurs first.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(iii) Broadway Media will use the dates provided at the time of the order unless corrected in advance of the license period.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(iv) Changes in performance dates that require adjustments to the rental term/license period will be classified as cancellations.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(v) To be eligible for a refund, your order must be unused and in the same condition as you received it. In the case of digital delivery, this means that the content must not have been downloaded and should remain unused.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(vi) If the content has been downloaded, the order is no longer in its original condition. Please note that Broadway Media monitors IP address activity and any download activity on your account.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `B. Cancellation Refund Approval`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `If the requirements for Cancellation Refund Eligibility have been met, the following applies to any cancellation request for a refund:`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(i) All requests must be made directly with Broadway Media, not through an agent or reseller, using the attached Order Cancellation Form.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `(ii) Depending upon the date of notice and any actual costs incurred by Broadway Media (e.g., restocking fees from the distributor, shipping costs, processing, etc.), you may incur a cancellation fee of up to 25% of your total order fee for the goods and services.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `C. Cancellation Credit Eligibility`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `Orders ineligible for normal cancellation refund eligibility may still be eligible for a full or partial credit for the unused portion at the discretion of the company. Please note that personal preference regarding product quality and style does not fulfill the eligibility criteria for a Cancellation Credit.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `D. Cancellation Credit Approval`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `To denote a specific Failure beyond user control, you must timely submit documented evidence to Broadway Media. Broadway Media reserves the right to provide technical support to assist you in achieving industry-accepted performance and remedy user failures. Cancellation credit requests will be reviewed by Broadway Media on a case-by-case basis.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `E. Further Order Adjustments`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `If your order does not meet the criteria for a cancellation refund or credit, Broadway Media will continue working with you to adjust your order. We may grant access to an alternative product(s) to meet your production needs. Cancellations due to acts of God (e.g., illness, death, or weather) shall be rescheduled within six (6) months of the original license period term.`,
                      },
                    },
                  ],
                }}
              />
            </Col>
          </Row>
        </div>
      </ReusableSection>
    </CatalogLayout>
  );
}
